export default __webpack_public_path__ + "static/media/filterBtn.05b3a77c.svg";